<div class="p-6">
  <app-card>
    <form [formGroup]="queryForm">
      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.timeseries.search.start' | translate }}</label>
            <input type="date" appInputDate [defaultDate]="false" formControlName="start">
          </app-input-group>
        </div>

        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.timeseries.search.resolution' | translate }}</label>
            <select appSelect formControlName="resolution" [collection]="timeseriesResolution">
            </select>
          </app-input-group>
        </div>

        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.timeseries.search.dataHubStatus' | translate }}</label>
            <select appSelect formControlName="dataHubStatus" [collection]="dataHubStatus">
            </select>
          </app-input-group>
        </div>

        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.timeseries.search.source' | translate }}</label>
            <select appSelect formControlName="source" [collection]="source">
            </select>
          </app-input-group>
        </div>
      </div>

      <div class="flex gap-4">
        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.timeseries.search.onlyLatest' | translate }}</label>
            <select appSelect formControlName="onlyLatest" [collection]="onlyLatest">
            </select>
          </app-input-group>
        </div>

        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.timeseries.search.readingType' | translate }}</label>
            <select appSelect formControlName="consumptionType" [collection]="consumptionType">
          </select>
          </app-input-group>
        </div>

        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.timeseries.search.estimationMethod' | translate }}</label>
            <select appSelect formControlName="estimationMethod" [collection]="estimationMethod">
            </select>
          </app-input-group>
        </div>

        <div class="w-1/4">
          <app-input-group>
            <label appLabel>{{ 'meteringPoint.timeseries.search.packageId' | translate }}</label>
            <input type="text" appInput formControlName="packageId" placeholder="Angiv pakkenummer">
          </app-input-group>
        </div>
      </div>

    </form>
    <div class="flex mt-1">
      <button appButton (click)="onSearch()" [disabled]="!queryForm.valid">
        {{ 'common.search' | translate }}
      </button>
    </div>
  </app-card>

  @if (showGraph) {
    <app-timeseries-graph
      #graph
      class="block mt-4"
      [config]="graphConfig"
    ></app-timeseries-graph>
  }

  <app-table
    #table
    [config]="timeSeriesTable"
  ></app-table>
</div>
